module.exports = __webpack_public_path__ + "img/total-number.67372822.svg";